import type { BookingRankingItem } from "@/types";
import { money } from "./metrics";

export function RankingList({
  title,
  items,
  currency,
}: {
  title: string;
  items?: BookingRankingItem[];
  currency: string;
}) {
  if (!items || items.length === 0) return null;
  const max = Math.max(...items.map((item) => item.count), 1);

  return (
    <section className="rounded-xl border border-border bg-card">
      <h2 className="border-b border-border p-4 text-sm font-medium">{title}</h2>
      <div className="space-y-1 p-2">
        {items.map((item) => {
          const width = `${Math.round((item.count / max) * 100)}%`;
          return (
            <div key={`${item.id}-${item.name}`} className="relative rounded-lg px-3 py-2">
              <div
                className="absolute inset-y-0 left-0 rounded-lg bg-muted"
                style={{ width }}
              />
              <div className="relative flex items-center justify-between gap-3">
                <div>
                  <p className="text-sm font-medium">{item.name}</p>
                  <p className="text-xs text-muted-foreground">
                    {item.count} citas
                    {item.revenue_cents != null
                      ? ` · ${money(item.revenue_cents, currency)}`
                      : ""}
                  </p>
                </div>
                <span className="text-xs text-muted-foreground">{width}</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
